<template>
  <div>
    <div class="operation">
      <div class="search">
        <!-- 商品名称/商品ID/商品链接 -->
        <div class="item input">
          <el-input clearable v-model="datas.title_iid_link"
            :placeholder="$t('message.productName_ProductID_ProductLink')" @blur="setDefaultValue"></el-input>
        </div>
        <!-- 工厂名称/工厂ID/工厂链接 -->
        <div class="item input">
          <el-input clearable v-model="datas.shop_id_name_link"
            :placeholder="$t('message.factoryNameFactoryIDFactoryLink')" @blur="setDefaultValue"></el-input>
        </div>
        <!-- 商品管理番号 -->
        <div class="item input">
          <el-input clearable v-model="datas.client_sku_code" :placeholder="$t('message.managementDesignation')"
            @blur="setDefaultValue"></el-input>
        </div>
        <!-- 是否绑定辅料 -->
        <div class="item select">
          <el-select v-model="datas.has_material" :placeholder="$t('message.whetherToBindAuxiliaryMaterials')"
            clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 是否绑定标签 -->
        <div class="item select">
          <el-select v-model="datas.has_tag" :placeholder="$t('message.isTheLabelBound')" clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 是否设置OPTION -->
        <div class="item select">
          <el-select v-model="datas.has_option" :placeholder="$t('message.doYouWantToSetOPTION')" clearable>
            <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 商品标签（多选） -->
        <div class="item select">
          <el-select v-model="datas.flag_id" :placeholder="$t('message.productLabelMultipleChoice')" clearable multiple>
            <el-option v-for="item in flagList" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </div>
        <!-- 标识 -->
        <div class="item select" style="margin-right: 0;">
          <el-select v-model="datas.edit_status" :placeholder="$t('message.identifier')" clearable>
            <el-option v-for="item in edit_status_options" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>
    </div>
    <div class="operation">
      <div class="search">
        <!-- 客户ID/客户名称 -->
        <div class="item input">
          <el-input clearable v-model="datas.user_id" :placeholder="$t('message.customerID_CustomerName')"
            @blur="setDefaultValue"></el-input>
        </div>
        <!-- 商品管理备注 -->
        <div class="item input">
          <el-input clearable v-model="datas.remark" :placeholder="$t('message.productManagementRemarks')"
            @blur="setDefaultValue"></el-input>
        </div>
        <!-- 管理番号模糊搜索-->
        <div class="item input">
          <el-input clearable v-model="datas.client_sku_code_like"
            :placeholder="$t('message.fuzzySearchByManagementNumber')"></el-input>
        </div>
        <!-- 选择产品类型 -->
        <div class="item select">
          <el-select v-model="datas.supply_type" :placeholder="$t('message.selectProductType')" clearable multiple>
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 番号状态筛选 -->
        <div class="item select">
          <el-select v-model="datas.is_hide" :placeholder="$t('message.serialNumberStatusFilter')" clearable>
            <el-option label="正常" value="0">
            </el-option>
            <el-option label="隐藏" value="1"></el-option>
          </el-select>
        </div>
        <!-- 审核状态 -->
        <div class="item select" v-if="auditMode">
          <el-select v-model="datas.audit_status" placeholder="审核状态筛选" clearable>
            <el-option v-for="item in auditStatusOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <!-- 搜索 -->
        <el-button type="primary" @click="search">{{ $t('message.search') }}</el-button>
        <!-- 重置 -->
        <el-button @click="reset">{{ $t('message.reset') }}</el-button>
        <!--  -->
      </div>
      <!-- 按钮区域 -->
      <div class="btn">
        <!-- 批量维护 -->
        <el-button v-if="!auditMode" type="danger" @click="batchProductManagement">{{
          $t('message.batchMaintenance')
        }}</el-button>
        <!-- 批量标识 -->
        <el-button v-if="!auditMode" type="danger" @click="batchIdentification">{{
          $t('message.batchIdentification')
        }}</el-button>
        <!-- 批量打回 -->
        <el-button v-if="auditMode" type="warning" @click="$emit('batchAudit', 'reject')">批量打回</el-button>
        <!-- 批量审核 -->
        <el-button v-if="auditMode" type="success" @click="$emit('batchAudit', 'approve')">批量审核</el-button>
        <!-- 列表展开收起 -->
        <el-button @click="isShow">
          {{ !allShow ? $t('message.listExpansion') : $t('message.listCollapse') }}
        </el-button>
      </div>
    </div>
    <div class="operation">
      <div class="search">
      </div>
      <!-- 按钮区域 -->
      <div class="btn">
        <!-- 客户商品数据导出(全量) -->
        <el-button type="primary" class="primary" @click="productListExport(1)" v-if="isAuth(632)">{{
          $t('message.customerProductDataExportAll')
        }}</el-button>
        <!-- 客户商品数据导出 -->
        <el-button type="primary" class="primary" @click="productListExport(0)" v-if="isAuth(633)">{{
          $t('message.customerProductDataExport')
        }}</el-button>
        <!-- 商品数据一件导入 -->
        <el-button type="primary" class="primary" @click="importOneItemOfProductData">{{
          $t('message.importOneItemOfProductData')
        }}</el-button>
      </div>
    </div>
    <!--批量标识维护状态 -->
    <labelEdit ref="labelEdit" :tableData="tableData" :checkList="checkList" />
    <!-- 导入 -->
    <importExcel ref="importExcel" @search="search" :user_id="datas.user_id" />
  </div>
</template>
<script>
import labelEdit from './labelEdit.vue'
import importExcel from './importExcel.vue'
import qs from 'qs'
export default {
  props: {
    tableData: { type: Array },
    auditMode: { type: Boolean, default: false }
  },
  components: {
    labelEdit, importExcel
  },
  data() {
    return {
      allShow: false,
      datas: {
        user_id: localStorage.getItem('product_user_id') ? localStorage.getItem('product_user_id') : '',
        title_iid_link: localStorage.getItem('product_title_iid_link') ? localStorage.getItem('product_title_iid_link') : '',
        shop_id_name_link: localStorage.getItem('product_shop_id_name_link') ? localStorage.getItem('product_shop_id_name_link') : '',
        client_sku_code: localStorage.getItem('product_client_sku_code') ? localStorage.getItem('product_client_sku_code') : '',
        remark: localStorage.getItem('product_remark') ? localStorage.getItem('product_remark') : '',
        audit_status: '',
      },
      options: [{ label: '是', value: 1 }, { label: '否', value: 0 }],
      typeOptions: [{ label: 'OEM', value: 'OEM' }, { label: 'ODM', value: 'ODM' }],
      flagList: [],
      checkList: [],
      edit_status_options: [
        { label: '待维护', value: '1' },
        { label: '维护完成', value: '2' },
        { label: '无需维护', value: '3' },
      ],
      auditStatusOptions: [
        { label: '无需审核', value: 1 },
        { label: '待审核', value: 2 },
        { label: '已审核', value: 3 },
        { label: '已驳回', value: 4 },
      ],
    };
  },
  created() {
    if (this.$route.query.product_user_id) {
      this.datas.user_id = this.$route.query.product_user_id
    }
    this.$api.productManagementApi.flagList().then(res => {
      this.flagList = res.data
    })
    this.$nextTick(() => {
      this.search()
    })

  },
  methods: {
    search() {
      this.datas.page = 1
      this.$emit('productList', this.datas)
    },
    reset() {
      this.datas = {
        user_id: '',
        title_iid_link: '',
        shop_id_name_link: '',
        has_material: '',
        has_option: '',
        client_sku_code: '',
        remark: '',
        has_tag: '',
        supply_type: [],
        flag_id: [],
        page: 1,
        pageSize: 10,
        client_sku_code_like: '',
        is_hide: '',
        audit_status: ''
      }
      this.setDefaultValue()
      this.$emit('productList', this.datas)
    },
    isShow() {
      this.allShow = !this.allShow
      this.$emit('isAllShow', this.allShow)

    },
    //设置默认值
    setDefaultValue() {
      localStorage.setItem('product_user_id', this.datas.user_id)
      localStorage.setItem('product_title_iid_link', this.datas.title_iid_link)
      localStorage.setItem('product_shop_id_name_link', this.datas.shop_id_name_link)
      localStorage.setItem('product_client_sku_code', this.datas.client_sku_code)
      localStorage.setItem('product_remark', this.datas.remark)
    },
    //批量标识
    batchIdentification() {
      this.checkList = []
      this.tableData.forEach(item => {
        if (item.checked) {
          this.checkList.push(item)
        }
      })
      if (this.checkList == false) return this.$message.error('请选择要操作的列表')
      this.$refs.labelEdit.dialogVisible = true
      this.$refs.labelEdit.edit_status = ''
    },
    //导出
    productListExport(type) {
      if (this.datas.user_id == '') return this.$message.error('请输入客户ID')
      this.loading = this.$loading({
        lock: true,
        text: "数据导出中",
        spinner: "el-icon-loading fontSize50",
        background: "rgba(255, 255, 255, 0.7)",
      });
      var xhr = new XMLHttpRequest();
      let url = this.baseURL + '/admin/product/productList/export';
      xhr.open("post", url, true,);
      xhr.responseType = "blob";
      xhr.setRequestHeader('accept', '*/*');
      xhr.setRequestHeader('accept-language', 'zh-CN');
      xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
      let user_token = localStorage.getItem('japan_access_token')
      xhr.setRequestHeader("admintoken", 'Bearer ' + user_token);
      let that = this;
      xhr.onload = function () {
        if (this.status == 200 && this.response.type != "text/html") {
          if (window.navigator.msSaveOrOpenBlob) { //IE浏览器
            navigator.msSaveBlob(this.response, `客户数据导出（${that.datas.user_id}）`);
          } else {//非IE浏览器
            var link = document.createElement("a");
            link.href = window.URL.createObjectURL(this.response);
            link.download = `客户数据导出（${that.datas.user_id}）`
            link.click();
            window.URL.revokeObjectURL(link.href);
            that.loading.close();
            that.$forceUpdate();
          }
        } else {
          console.log("响应出错啦!");
        }
      };
      xhr.send(qs.stringify({ user_id: this.datas.user_id, needAllMessage: type }));
    },
    //导入
    importOneItemOfProductData() {
      if (this.datas.user_id == '') return this.$message.error('请输入客户ID')
      // user_id 由父级单向传入，弹窗组件不再通过 ref 修改 prop。
      this.$refs.importExcel.open()
    },
    //批量维护
    batchProductManagement() {
      let sys_code_set = []
      this.tableData.forEach(item => {
        if (item.checked) {
          sys_code_set.push(item.sys_code)
        }
      })
      if (this.sys_code_set == false) return this.$message.error('请选择要操作的列表')
      let routeUrl = this.$router.resolve({
        path: "/batchProductManagement?sys_code_set=" + sys_code_set.join(','),
      });
      window.open(routeUrl.href);
    },
  }
}
</script>
<style lang='scss' scoped>
.operation {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;

  .search {
    display: flex;

    .item {
      margin-right: 20px;
    }

    .input {
      width: 200px;
    }

    .select {
      width: 200px;
    }
  }
}
</style>
